module.exports = __webpack_public_path__ + "static/media/feed-share.0dd23c59.svg";